import { useMemo } from 'react';
import { TacticStatus } from 'basics/enums/maya.enums';
import useGetAllTacticsQuery from 'basics/graphql/queries/getAllTactics';
import { Tactic, Channel } from 'generated/maya.types';

const useTacticOptions = (
  cepId: string | null,
  excludedTacticsId: string[] = [],
  channels: Channel[] = Object.values(Channel),
  statuses: TacticStatus[] = [TacticStatus.EMPTY, TacticStatus.DRAFT, TacticStatus.APPROVED],
  onlyWithoutParentTactic = false,
) => {
  const queryFilters = useMemo(
    () => ({
      cep: cepId,
      status: statuses,
    }),
    [cepId, statuses],
  );

  const { data: tactics } = useGetAllTacticsQuery(undefined, queryFilters);
  return tactics
    .filter((element: Tactic) => !excludedTacticsId.includes(element._id))
    .filter((element: Tactic) => channels.includes(element?.channel))
    .filter((element: Tactic) => {
      if (!onlyWithoutParentTactic) return true;
      return !element.parentTactic?._id;
    }).map((element: Tactic) => {
      return {
        id: element._id,
        label: element.title,
        channel: element.channel,
        formattedId: element.formattedTacticId,
      };
    });
};

export default useTacticOptions;
